import type { HTMLAttributes, ReactNode } from 'react';

interface AppCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  // Tighter padding for dense contexts (chat message bubbles) instead of
  // this card's normal roomy default - everywhere else keeps p-4 sm:p-5.
  compact?: boolean;
  // Sizes to its own content instead of stretching to fill the parent -
  // used by chat message bubbles, which shouldn't all stretch to the same
  // width regardless of how short/long the text actually is. Set at the
  // source rather than overridden via a caller className, since a plain
  // "w-auto" in a later class can't reliably beat this card's own w-full
  // (same CSS specificity - whichever utility Tailwind happens to emit
  // later in the stylesheet wins, not whichever appears later in the
  // class list).
  fitWidth?: boolean;
}

export function AppCard({ children, className = '', compact = false, fitWidth = false, ...rest }: AppCardProps) {
  return (
    <div
      className={
        (fitWidth ? 'w-fit ' : 'w-full ') +
        'rounded-2xl border border-black/[0.06] dark:border-white/[0.08] bg-white/70 dark:bg-white/[0.06] backdrop-blur-xl ' +
        (compact ? 'px-3 py-2 ' : 'p-4 sm:p-5 ') +
        className
      }
      {...rest}
    >
      {children}
    </div>
  );
}
